export * from './diseases.component';
